import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  /* Behavior Subjects */
  // Map report
  private mapPointGraphicSource = new BehaviorSubject<boolean>(false);
  private mapPointSelectedSource = new BehaviorSubject<boolean>(false);
  private userCommentsSource = new BehaviorSubject<string>(null);
  // Basin report
  private mapBasinPointSource = new BehaviorSubject<boolean>(false);
  private printMapReportSource = new BehaviorSubject<boolean>(false);
  private basinSelectedSource = new BehaviorSubject<boolean>(false);
  private printBasinReportSource = new BehaviorSubject<boolean>(false);

  /* Observables */
  // Map report
  mapPointGraphic = this.mapPointGraphicSource.asObservable();
  mapPointSelected = this.mapPointSelectedSource.asObservable();
  userComments = this.userCommentsSource.asObservable();
  printMapReport = this.printMapReportSource.asObservable();
  // Basin report
  mapBasinPoint = this.mapBasinPointSource.asObservable();
  basinSelected = this.basinSelectedSource.asObservable();
  printBasinReport = this.printBasinReportSource.asObservable();

  constructor(private http: HttpClient) { }

  /* Map Report */

  // Print Map report point collection
  activatePointCollection(pointCollect: boolean) {
    this.mapPointGraphicSource.next(pointCollect);
  }

  // Update print map point selection status
  mapPointSelectedStatus(printMapPointSelected: boolean) {
    this.mapPointSelectedSource.next(printMapPointSelected);
  }

  // Update print user comments from map report
  userCommentsChange(userComms: string) {
    this.userCommentsSource.next(userComms);
  }

  // Print map report button
  activatePrintMapReport(printMapLayout: boolean) {
    this.printMapReportSource.next(printMapLayout);
  }

  /* Basin Report */

  // Print Basin selection for basin report
  activateBasinPointCollection(basinPointCollect: boolean) {
    this.mapBasinPointSource.next(basinPointCollect);
  }

  // Update print basin selection status
  basinSelectedStatus(printBasinSelected: boolean) {
    this.basinSelectedSource.next(printBasinSelected);
  }

  // Print basin report button
  activatePrintBasinReport(printBasinLayout: boolean) {
    this.printBasinReportSource.next(printBasinLayout);
  }

}
